import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-32" data-testid="not-found-page">
      <h1 className="font-display text-4xl sm:text-5xl text-[#0F2A52]">Page not found</h1>
      <p className="text-base text-[#4A4A4A] mt-6">That page doesn't exist. Let's get you back to the coast.</p>
      <Link
        to="/"
        className="inline-block mt-10 bg-[#0F2A52] text-[#FCFAF6] px-7 py-4 text-sm hover:-translate-y-1 hover:shadow-lg transition-transform duration-200"
        data-testid="notfound-home-link"
      >
        Back to home
      </Link>
    </main>
  );
}
